<template lang="html">
  <section class="custom-display-element-details">
    <div class="details">
      <div class="section">
        <custom-display-element-versions id="widget-versions" />
      </div>
      <div class="section">
        <custom-display-element-translations id="widget-translations" />
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import CustomDisplayElementVersions from "@/components/custom-display-elements/tabs/parts/CustomDisplayElementVersions";
  import CustomDisplayElementTranslations from "@/components/custom-display-elements/tabs/parts/CustomDisplayElementTranslations";

  export default  {
    name: "custom-display-element-details",
    components: {
      CustomDisplayElementVersions,
      CustomDisplayElementTranslations
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .custom-display-element-details {
    .details {
      display: flex;
      column-gap: 1rem;
      min-height: 50%;
      .section {
        flex-basis: 50%;
        max-width: 50%;
      }
    }
  }
</style>
